import { formatMoney } from "accounting";
import config, { domain } from "../config/enviroment";
import { DataService } from './dataService'
import { path } from "../config/enviroment";
import { catalogueUrlSegment } from './catalogueUrl';

declare global {
	interface Window {
		ePayco: any;
	}
}

/**
 *
 * @param cartId id del carrito
 * @param products productos del carrito
 * @param costDelivery objeto de costos de delivery
 * @param totalToPay total a pagar
 * @param taxBase total sin impuestos
 * @param taxAmount total iva
 * @param consumptionTaxAmount total ICO
 * @param totalDiscountAmount total descuento
 * @param name nombre del cliente
 * @param email email del cliente
 * @param phone telefono del clinete
 * @param address direccion del cliente
 * @param publicKey llave publica del carrito
 * @param currency tipo de moneda del catalogo
 * @param callback Se llama cuando se cierra el modal
 */

export const EpaycoCheckout = async (
	cartId: string,
	clientId: number,
	catalogueName: string,
	products: any[],
	costDelivery: any,
	totalToPay: number,
	taxBase: number,
	taxAmount: number,
	consumptionTaxAmount: number,
	totalDiscountAmount: number,
	discountCodeAmount: number,
	name: string,
	email: string,
	phone: string,
	address: string,
	publicKey: string,
	currency: string,
	document: any,
	callback: () => void,
	modeCheckout: string = "test",
) => {

	const _dataService = new DataService()

	let data = mapproducts(
		cartId,
		clientId,
		catalogueName,
		products,
		costDelivery,
		totalToPay,
		taxBase,
		taxAmount,
		consumptionTaxAmount,
		totalDiscountAmount,
		discountCodeAmount,
		name,
		email,
		phone,
		address,
		currency,
		document,
		modeCheckout,
	);


	let response = await _dataService
	.post('/catalogue/shoppingcart/getSessionId', { data: data, url: path });
	
	let sessionData = response.data;
	if (sessionData.success) {
		const configCheckout = {
			sessionId: sessionData.data.sessionId,
			type: "onepage",
			test: modeCheckout !== "prod",
		};
		let handler = window.ePayco.checkout.configure(configCheckout);
		handler.onErrors(callback);
		handler.onClosed(callback);

		handler.open();
	} else {
		throw new Error("there was an error");
	}
};

const getAddress = (address: string) => {
	let splitAddress = address.split(",");
	let state = "";
	let street = "";
	let details = "";
	if (splitAddress.length > 1) {
		street = splitAddress[0] !== null ? splitAddress[0] : "";
		let splitSate = splitAddress[1] !== null ? splitAddress[1].split("/") : "";
		if (splitSate.length > 1) {
			state = splitSate[0] !== null ? splitSate[0] : "";
			details = splitSate[1] !== null ? splitSate[1] : "";
		}
	}
	return {
		state: state,
		street: street,
		details: details,
	};
};

export const currencyFormat = (amount: number, currency: string) => {
	let amountFormat: string;
	switch (currency) {
		case "USD":
			amountFormat = formatMoney(amount, {
				symbol: "$",
				thousand: ",",
				decimal: ".",
				precision: 2,
			});
			break;
		case "COP":
			amountFormat = formatMoney(amount, {
				symbol: "$",
				thousand: ".",
				decimal: ",",
				precision: 2,
			});
			break;
		default:
			amountFormat = formatMoney(amount, {
				symbol: "$",
				thousand: ".",
				decimal: ",",
				precision: 2,
			});
			break;
	}

	return `${amountFormat} ${currency}`;
};

const mapproducts = (
	cartId: string,
	clientId: number,
	catalogueName: string,
	products: any[],
	costDelivery: any,
	totalToPay: number,
	taxBase: number,
	taxAmount: number,
	consumptionTaxAmount: number,
	totalDiscountAmount: number,
	discountCodeAmount: number,
	name: string,
	email: string,
	phone: string,
	address: string,
	currency: string,
	document: any,
	modeCheckout: string,
) => {
	const nameCheckout =
		products.length === 1
			? products[0].productData.title
			: `${products[0].productData.title} y más`;
	const descriptionChackout = products
		.map((item: any) => {
			let price = currencyFormat(
				item.productData.discountRate > 0
					? item.productData.discountPrice * item.quantity
					: item.productData.netAmount * item.quantity,
				currency
			);

			return `${item.productData.title} ${item.quantity} ${item.quantity > 1 ? "unidades" : "unidad"
				} ${price}`;
		})
		.join(" + ");
	let configCheckout = {
		//Parametros compra (obligatorio)
		checkout_version: config.epaycoCheckoutVersion,
		name: nameCheckout,
		description: descriptionChackout,
		invoice: cartId,
		currency,
		amount: totalToPay,
		taxBase: taxBase,
		tax: taxAmount,
		taxIco: consumptionTaxAmount,
		country: "co",
		lang: "es",
		test: modeCheckout !== "prod",
		//Atributos opcionales
		method: "POST",
		confirmation: `${config.api}/catalogue/shoppingcart/checkout/confirmation`,
		response: `${domain}/vende/${catalogueUrlSegment(catalogueName)}/purchase/${cartId}`,
		//Opcion response para developer en local
		// response: `${window.location.hostname === 'localhost' ? ('http://'+window.location.host) : domain }/vende/tecnos/purchase/${cartId}`,
		extras: {
			extra10: JSON.stringify({ totalDiscountProduct: (totalDiscountAmount - discountCodeAmount), totalDiscountCode: discountCodeAmount }),
			extra9: JSON.stringify(costDelivery),
			extra8: discountCodeAmount !== 0 ?
				`Descuento por producto: ${totalDiscountAmount - discountCodeAmount} + Descuento por código: ${discountCodeAmount}` :
				`Descuento: ${totalDiscountAmount}`,
			extra7: "EPAYCO",
			extra1: name,
			extra2: email,
			extra3: getAddress(address).state,
			extra4: getAddress(address).street,
			extra5: getAddress(address).details,
		},
		extrasEpayco: {
			"extra1": "prueba"
		},
		//Atributos cliente
		billing: {
			email: email,
			name: name,
			address: address,
			typeDoc: "CC",
			numberDoc: null,
			callingCode: "+57",
			mobilePhone: phone
		},
	};
	return configCheckout;
};
